import {
  assert_equal,
  assert_not_null,
  assert_number_gte_0,
  assert_string_hash_sha256,
  assert_string_object_id,
  assert_string_object_id_not_empty,
  assert_type_enum,
} from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_IMAGE_META__base } from '../_base/DTO_IMAGE_META__base';
import { INTERFACE_IMAGE_META__grid2d_cell } from './INTERFACE_IMAGE_META__grid2d_cell';

export class DTO_IMAGE_META__grid2d_cell_generation extends DTO_IMAGE_META__base implements INTERFACE_IMAGE_META__grid2d_cell {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.IMAGE_META__GRID2D_CELL_GENERATION;

  /*
   * STATIC METHODS
   */

  static filter_by_type(items: DTO_IMAGE_META__base[]) {
    return items.filter(item => item instanceof DTO_IMAGE_META__grid2d_cell_generation);
  }

  /*
   * FIELDS
   */

  graph_id!: string;

  //todo: mb need add node_id + field id for row+ column

  value_column!: any;
  value_row!: any;

  x!: number;
  y!: number;

  field_hash__value_full!: string;
  field_hash__value_clean!: string;

  graph!: DTO_GRAPH__instance;

  grid2d_id!: string;
  grid2d_type!: ENUM__workspace_entity;
  grid2d_chunk_id!: string;

  /*
   * RUNTIME FIELDS
   */

  /*
   * PROPERTIES
   */

  set generation_id(value: string) {
    assert_string_object_id_not_empty(value);

    this.graph_id = value;
    this.grid2d_id = value;
    this.grid2d_chunk_id = value;
  }

  /*
   * METHODS
   */
  constructor() {
    super();

    this.graph = DTO_GRAPH__instance.CREATE_STUB();

    this.grid2d_type = ENUM__workspace_entity.ENTITY_GENERATION;
  }

  get_key_for_generation(): string {
    assert_string_object_id(this.grid2d_id);

    assert_number_gte_0(this.x);
    assert_number_gte_0(this.y);

    return `${this.grid2d_id}_${this.x}_${this.y}`;
  }

  /*
   * ASSERTS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_object_id_not_empty(this.graph_id);

    assert_number_gte_0(this.x);
    assert_number_gte_0(this.y);

    assert_not_null(this.value_column);
    assert_not_null(this.value_row);

    assert_string_hash_sha256(this.field_hash__value_full);
    assert_string_hash_sha256(this.field_hash__value_clean);

    assert_string_object_id(this.grid2d_id);
    assert_type_enum(this.grid2d_type, ENUM__workspace_entity);
    assert_string_object_id(this.grid2d_chunk_id);

    assert_equal(this.grid2d_id, this.grid2d_chunk_id);
  }
}
